<template>
    <b-overlay :show="tableLoading" rounded="sm" >
        <b-card class="inner-block activity-category">
            <b-card-header>
                <b-row class="mt-2">
                    <b-col cols="12" class="d-flex">
                        <b-input id="search_activity_category" type="text" :placeholder="$translate('search_activity_category')" v-model="filter"></b-input>
                        <slot></slot>
                    </b-col>
                </b-row>
            </b-card-header>
            <b-card-body>
                <b-col class="page-block"><strong> {{ $translate('page') }}: {{ currentPage }} {{ $translate('of') }} {{
                    Math.ceil(rows / itemsPerPage) }} {{ $translate('total') }}:
                        {{ rows }}</strong></b-col>
                <b-col class="overflow-auto w-100 mt-4">
                    <b-table :fields="fields" responsive :items="items" :per-page="itemsPerPage"
                        :current-page="currentPage" :filter="filter">
                        <template>
                            <div class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <!-- <strong>{{ $translate('loading') }}</strong> -->
                            </div>
                        </template>
                        <template #cell(id)="row">
                            <b-button :id="'view-category-btn-'+row.item.id"  @click="$emit('show-item', row.item.id)" v-if="hasPermissionView" class="me-2 test-view-category-btn"
                                variant="pink-button">
                                <img src="@/assets/images/icon/view.svg" />
                            </b-button>
                        </template>
                    </b-table>
                </b-col>
            </b-card-body>
            <b-row>
                <b-col>
                    <b-pagination class="justify-content-center mt-4" :prev-text="$translate('previous')"
                        :next-text="$translate('next')" v-model="currentPage" :total-rows="rows" :per-page="itemsPerPage"
                        aria-controls="roleTable" pills align="right"></b-pagination>
                </b-col>
            </b-row>
        </b-card>
    </b-overlay>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'activityCategories-ListItems',
    mixins: [popupMixins, permissionsMixins],
    props: {
        //type, // not used

        /**
         * List of items to  be displayed in the table
         */
        items: Array,
        /**
         * The title of the table
         */
        title: String,
    },

    data() {
        return {
            filter: '',
            tableLoading: false,
            itemsPerPage: 15,
            currentPage: 1,
        }
    },

    mounted() {
        this.doSearch()
    },
    watch: {
        categories: {
            handler: function () {
                this.tableLoading = false
            },
            deep: true,
        },
    },


    methods: {
        async doSearch() {
            this.tableLoading = true
           await this.$store.dispatch('orderCategory/fetchAll')
        },

        deleteItem(id) {
            let item = this.items.find(el => el.id == id)

            const title = 'Delete Type?'
            const message = `${this.$translate('delete_note')} ${item.name}?`
            this.confirmMessage(title, message).then(result => {
                if (result) {
                    this.$store
                        .dispatch('orderCategory/delete', id)
                        .then(() => {
                            this.genericToast(this.componentName, 'Deleted', 'success', `"${item.name}"" deleted successfully`)
                        })
                        .catch(error => {
                            console.error(error)
                            this.doToast(
                                this.$translate('error'),
                                error.message,
                                'danger'
                            )
                        })
                }
            })
        },
    },

    computed: {
        componentName() { return this.$translate('activity_category') },
        fields() {
            return [
                { key: 'id', label: this.$translate('actions') },
                { key: 'name', label: this.$translate('name') },
            ]
        },

        categories() {
            const categories = this.$store.state.orderCategory.categories
            console.log('categories', categories)
            return categories
        },
        user() {
            return this.$store.state.user
        },

        rows() {
            return this.items.length
        }

    },
}
</script>
<style></style>
